var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gray-box",class:`gray-box-${_vm.type}`})
}
var staticRenderFns = []

export { render, staticRenderFns }